import { render, staticRenderFns } from "./Searchform.vue?vue&type=template&id=53f2a700&"
import script from "./Searchform.vue?vue&type=script&lang=js&"
export * from "./Searchform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VTextField})
